<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small">
  <input #input type="text" [lgdCurrency]="config" [formControl]="formControl" autocomplete="off">
  @if (!hideLabel) {
    <label slot="label">{{label}}</label>
  }

  <span slot="support-text">
    @if (showErrorMessage('required')) {
      {{label}} is required
    }

    @if (showErrorMessage('min')) {
      {{label}} cannot be less than {{min | currency:'USD':'symbol':digitsInfo}}
    }

    @if (showErrorMessage('max')) {
      {{label}} cannot be more than {{max | currency:'USD':'symbol':digitsInfo}}
    }

    @if (showErrorMessage('precision')) {
      {{label}} cannot have more than {{precision}} digits
    }

    @if (showErrorMessage('scale')) {
      {{label}} cannot have more than {{scale}} decimal digits
    }

    @for (customError of customErrors; track customError) {
      @if (showErrorMessage(customError.errorKey)) {
        {{customError.message}}
      }
    }
  </span>

  <forge-tooltip>{{tooltip}}</forge-tooltip>
</forge-text-field>